import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-407bb771"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "strategy-details-container" }
const _hoisted_2 = { class: "card strategy-yield-card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "策略收益(模拟)", -1))
const _hoisted_4 = { class: "yield-stats" }
const _hoisted_5 = { class: "stat-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "年化收益", -1))
const _hoisted_7 = { class: "stat-item" }
const _hoisted_8 = { class: "stat-value rise-text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "平均胜率", -1))
const _hoisted_10 = { class: "stat-item" }
const _hoisted_11 = { class: "stat-value neutral-text" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "盈亏比", -1))
const _hoisted_13 = { class: "stat-item" }
const _hoisted_14 = { class: "stat-value neutral-text" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "最大回撤", -1))
const _hoisted_16 = {
  key: 0,
  class: "card strategy-logic-card"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "策略逻辑说明", -1))
const _hoisted_18 = { class: "logic-body" }
const _hoisted_19 = {
  key: 0,
  class: "logic-section"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "策略介绍", -1))
const _hoisted_21 = { class: "logic-list" }
const _hoisted_22 = { class: "logic-item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "策略名称", -1))
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "logic-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "策略介绍", -1))
const _hoisted_27 = { class: "value" }
const _hoisted_28 = {
  key: 0,
  class: "logic-section"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "选股因子", -1))
const _hoisted_30 = { class: "logic-list" }
const _hoisted_31 = { class: "label" }
const _hoisted_32 = { class: "value" }
const _hoisted_33 = {
  key: 1,
  class: "logic-section"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "选股范围", -1))
const _hoisted_35 = { class: "logic-list" }
const _hoisted_36 = { class: "label" }
const _hoisted_37 = { class: "value" }
const _hoisted_38 = { class: "logic-section" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "买卖规则", -1))
const _hoisted_40 = { class: "logic-list" }
const _hoisted_41 = { class: "logic-item" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "买入规则", -1))
const _hoisted_43 = { class: "value" }
const _hoisted_44 = { class: "logic-item" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "卖出规则", -1))
const _hoisted_46 = { class: "value" }
const _hoisted_47 = { class: "logic-section" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "仓位控制", -1))
const _hoisted_49 = { class: "logic-list" }
const _hoisted_50 = { class: "logic-item" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "初始资金", -1))
const _hoisted_52 = { class: "value" }
const _hoisted_53 = { class: "logic-item" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "个股最大持仓", -1))
const _hoisted_55 = { class: "value" }
const _hoisted_56 = { class: "logic-item" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "账户最大持股数", -1))
const _hoisted_58 = { class: "value" }
const _hoisted_59 = { class: "logic-item" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "单日最大买入数", -1))
const _hoisted_61 = { class: "value" }
const _hoisted_62 = { class: "logic-section" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "回测周期", -1))
const _hoisted_64 = { class: "logic-list" }
const _hoisted_65 = { class: "logic-item" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "回测周期", -1))
const _hoisted_67 = { class: "value" }
const _hoisted_68 = {
  key: 1,
  class: "stock-logic-box"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stock-logic-title" }, "策略逻辑说明", -1))
const _hoisted_70 = { class: "stock-logic-row" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stock-logic-label" }, "买入信号", -1))
const _hoisted_72 = { class: "stock-logic-value" }
const _hoisted_73 = { class: "stock-logic-row" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stock-logic-label" }, "卖出信号", -1))
const _hoisted_75 = { class: "stock-logic-value" }




export default /*#__PURE__*/_defineComponent({
  __name: 'StrategyDetails',
  props: {
    strategyDetails: null,
    isDark: { type: Boolean },
    isFactor: { type: Boolean },
    isStock: { type: Boolean },
    isAi: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  strategyDetails: any
  isDark: boolean
  isFactor: boolean
  isStock?: boolean
  isAi?: boolean
}



const formatPercent = (val: number | undefined) => {
  if (val == null) return '--'
  const pct = val * 100
  return (pct > 0 ? '' : '') + pct?.toFixed(2) + '%'
}

const formatNumber = (val: number | undefined, decimals: number) => {
  if (val === undefined || val == null) return '0.000'
  const factor = Math.pow(10, decimals)
  const truncated = Math.trunc(val * factor) / factor
  return truncated.toFixed(decimals)
}

const getColorClass = (val: number | undefined) => {
  if (val === undefined) return 'neutral-text'
  if (val > 0) return 'rise-text'
  if (val < 0) return 'fall-text'
  return 'neutral-text'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["yield-value", getColorClass(__props.strategyDetails.summary?.cumRet)])
      }, _toDisplayString(formatPercent(__props.strategyDetails.summary?.cumRet)), 3),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["stat-value", getColorClass(__props.strategyDetails.summary?.annRet)])
          }, _toDisplayString(formatPercent(__props.strategyDetails.summary?.annRet)), 3),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(formatPercent(__props.strategyDetails.summary?.winRate)), 1),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, _toDisplayString(formatNumber(__props.strategyDetails.summary?.plRatio, 3)), 1),
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(formatPercent(__props.strategyDetails.summary?.maxDD)), 1),
          _hoisted_15
        ])
      ])
    ]),
    (!__props.isStock)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            (__props.strategyDetails.comResult?.req?.isWatchWord)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("span", _hoisted_24, _toDisplayString(__props.strategyDetails.comResult?.req?.strategyName || '--'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("span", _hoisted_27, _toDisplayString(__props.strategyDetails.comResult?.req?.strategyNote || '--'), 1)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (__props.strategyDetails.comResult?.req?.factorBuy?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.strategyDetails.comResult?.req?.factorBuy, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "logic-item",
                              key: index
                            }, [
                              _createElementVNode("span", _hoisted_31, _toDisplayString(item.nameShow), 1),
                              _createElementVNode("span", _hoisted_32, _toDisplayString(item.valueShow || '--'), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.strategyDetails.comResult?.req?.stockRange?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("div", _hoisted_35, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.strategyDetails.comResult?.req?.stockRange, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "logic-item",
                              key: index
                            }, [
                              _createElementVNode("span", _hoisted_36, _toDisplayString(item.nameShow), 1),
                              _createElementVNode("span", _hoisted_37, _toDisplayString(item.valueShow || '--'), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64)),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("span", _hoisted_43, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.strategyDetails.comResult?.req?.ruleBuy, (rule, idx) => {
                      return (_openBlock(), _createElementBlock("div", { key: idx }, _toDisplayString(rule || '--'), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createElementVNode("span", _hoisted_46, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.strategyDetails.comResult?.req?.ruleSell, (rule, idx) => {
                      return (_openBlock(), _createElementBlock("div", { key: idx }, _toDisplayString(rule || '--'), 1))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("span", _hoisted_52, _toDisplayString(__props.strategyDetails.comResult?.req?.initialFund || '--'), 1)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("span", _hoisted_55, _toDisplayString(__props.strategyDetails.comResult?.req?.positionLimit || '--'), 1)
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  _createElementVNode("span", _hoisted_58, _toDisplayString(__props.strategyDetails.comResult?.req?.maxHolds || '--'), 1)
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _hoisted_60,
                  _createElementVNode("span", _hoisted_61, _toDisplayString(__props.strategyDetails.comResult?.req?.dayLimit || '--'), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _hoisted_63,
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _createElementVNode("span", _hoisted_67, _toDisplayString(__props.strategyDetails.comResult?.req?.period || '--'), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.isStock)
      ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
          _hoisted_69,
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createElementVNode("span", _hoisted_72, _toDisplayString((__props.isAi
            ? (__props.strategyDetails.req?.factorBuy || [])
            : (__props.strategyDetails.customResult?.req?.factorBuy || [])
          ).join('；') || '--'), 1)
          ]),
          _createElementVNode("div", _hoisted_73, [
            _hoisted_74,
            _createElementVNode("span", _hoisted_75, _toDisplayString((__props.isAi
            ? (__props.strategyDetails.req?.factorSell || [])
            : (__props.strategyDetails.customResult?.req?.factorSell || [])
          ).join('；') || '--'), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})